import React, { forwardRef } from 'react';
import styled from '@xstyled/styled-components';
import { ChatMessage } from '~/training/sequence/templates/items/chatBot/components/chat/ChatMessage';
import { ChatLoader } from '~/training/sequence/templates/items/chatBot/components/chat/ChatLoader';
import { MessageData } from '~/training/sequence/templates/items/chatBot/hooks/useWebSocketChat';

const Conversation = styled.section`
  flex: 1 1 auto;
  overflow-y: scroll;
  padding: 0 120px;

  @media (max-width: 768px) {
    padding: 0 20px;
  }
`;

const Messages = styled.ol``;

interface ChatMessageListProps {
  messages: MessageData[];
  loading: boolean;
  botTitle: string;
}

export const ChatMessageList = forwardRef<HTMLElement, ChatMessageListProps>(
  ({ messages, loading, botTitle }, ref) => {
    return (
      <Conversation
        aria-label="Conversation"
        role="log"
        aria-live="polite"
        aria-relevant="additions"
        aria-atomic="false"
        ref={ref}
      >
        <Messages>
          {messages && messages.length
            ? messages.map((message, index) => (
                <ChatMessage
                  key={`message_${index}`}
                  message={message}
                  messageNumber={index + 1}
                  botTitle={botTitle}
                />
              ))
            : null}
          {loading && <ChatLoader />}
        </Messages>
      </Conversation>
    );
  }
);
